import { Menu, MenuProps, PopoverActions } from "@mui/material";
import React, { RefObject, useEffect, useMemo, useRef } from "react";
import { useScrollbarWidth } from "../../hooks/useScrollbarWidth";

const CustomMenu = React.forwardRef(
  (
    props: MenuProps & {
      popoverActionRef?: RefObject<PopoverActions>;
    },
    ref
  ) => {
    const popoverActions =
      props.popoverActionRef || useRef<PopoverActions>(null);
    const scrollWidht = useScrollbarWidth();
    const shouldCleanOverflow = useMemo(() => {
      return document.documentElement.style.overflow !== "hidden";
    }, []);

    const defaultHTMLOverflow = useMemo(() => {
      return document.documentElement.style.overflow;
    }, []);

    const defaultHTMLPadding = useMemo(() => {
      return document.documentElement.style.paddingRight;
    }, []);

    const shouldScrollLockHTML = !props.disableScrollLock;

    const htmlDoc = document.documentElement;

    useEffect(() => {
      setTimeout(() => {
        popoverActions.current?.updatePosition();
      }, 0);
      const isOverflowing =
        htmlDoc.scrollHeight > htmlDoc.clientHeight ||
        htmlDoc.scrollWidth > htmlDoc.clientWidth;
      if (props.open && shouldScrollLockHTML && isOverflowing) {
        htmlDoc.style.overflow = "hidden";
        htmlDoc.style.paddingRight = `${scrollWidht}px`;
      } else {
        htmlDoc.style.overflow = defaultHTMLOverflow;
        htmlDoc.style.paddingRight = defaultHTMLPadding;
      }

      return () => {
        if (shouldCleanOverflow) {
          htmlDoc.style.overflow = defaultHTMLOverflow;
          htmlDoc.style.paddingRight = defaultHTMLPadding;
        }
      };
    }, [props.open]);

    // if(props.open){
    //   window.document.
    // }
    return (
      <>
        {props.open && !props.disableScrollLock && (
          <style
            dangerouslySetInnerHTML={{
              __html: `
      html {
        overflow: hidden
      }
    `,
            }}
          />
        )}
        <Menu {...props} action={popoverActions} ref={ref as any} />
      </>
    );
  }
);

export default CustomMenu;
